/**
 * Единый список пространств имён, которые ЗАГРУЖАЕТ рантайм i18next.
 *
 * ЗАЧЕМ ОТДЕЛЬНЫЙ ФАЙЛ. AD-107 зафиксировал пять независимых списков пространств:
 * `ns` в `src/i18n/config.ts` (рантайм), `LANGUAGES` в `scripts/export-locales.ts`
 * (генератор `public/locales`), `resources` в `src/types/i18next.d.ts` (типизация
 * ключей), `NAMESPACES` в `scripts/i18n-coverage.ts` (страж покрытия) и набор
 * файлов на диске. Они разъехались молча: страж мерил восемь пространств, рантайм
 * грузил тринадцать — и 441 отсутствующий ключ лежал ВНЕ области стража, то есть
 * гейт был зелёным по построению (суженная область = ложная зелень).
 *
 * Здесь снят один из пяти списков: рантайм и страж покрытия читают теперь один
 * массив. Остальные три сведены НЕ здесь и намеренно:
 *   • генератор `export-locales.ts` экспортирует девять пространств, и расширить
 *     его до этого списка нельзя молча — у `campaigns`/`surveys` файлы в
 *     `public/locales/{en,ru}` БОГАЧЕ своих TS-источников (42 против 19 и 67
 *     против 35 ключей), перегенерация вычла бы ключи с живых экранов;
 *   • у `badges` и `legal` TS-источника нет вовсе — только `public/locales`;
 *   • `i18next.d.ts` типизирует ровно те девять, что экспортирует генератор.
 * Что делать с этими четырьмя — решение владельца, оно записано в AD-107.
 */
export const RUNTIME_NAMESPACES = [
  "common",
  "dashboard",
  "widgets",
  "test",
  "tasks",
  "notifications",
  "support",
  "events",
  "documents",
  "surveys",
  "campaigns",
  "badges",
  "legal",
] as const;

export type RuntimeNamespace = (typeof RUNTIME_NAMESPACES)[number];
